import { Box, Button, Dialog, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const MetaMaskInstalled = ({ openModal }) => {
  const [isAccountCreated, setIsAccountCreated] = useState(false);
  useEffect(() => {
    if (typeof window.ethereum !== "undefined") {
      setIsAccountCreated(false);
    } else {
      setIsAccountCreated(true);
    }
  }, []);

  return (
    <div>
      <Dialog
        open={isAccountCreated}
        onClose={() => setIsAccountCreated(false)}
      >
        <Box
          sx={{
            marginLeft: "auto",
            marginRight: "auto",
            p: 3,
            width: { md: "350px", xs: "80%" },
            textAlign: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Looks like you haven't installed MetaMask yet.
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() =>
              window.open("https://metamask.io/download/", "_blank")
            }
          >
            Download MetaMask Plugin
          </Button>
        </Box>
      </Dialog>
    </div>
  );
};

export default MetaMaskInstalled;
